import React, { useCallback, useEffect, useRef, useState } from "react";
import { FetchDataTypes } from "../../api/api";
import Cookies from "js-cookie";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useGetDashboardData } from "../../data/data";
import { formateAsPercent, formateDataPrec } from "../../utils/types";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { boolean } from "yup";
import _ from "lodash";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const HistoricalPerformance = () => {
  const [data, setData] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  const [selectedYear, setSelectedYear] = useState(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  //   const { data, isFetching, refetch } = useGetDashboardData(
  //     "HistoricalParticipantPerformance",
  //     Cookies.get("newJwt")
  //   );
  useEffect(() => {
    FetchDataTypes(
      "HistoricalParticipantPerformance",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setData(response);
      });
  }, []);

  const filterByEndDate = _.uniqBy(data, "year");

  function handleSelectedDate(e: any) {
    setSelectedYear(e.target.value);
  }

  const filteredData = _.filter(data, (item) => {
    if (!selectedYear) {
      return true;
    }
    return item.year.toString() === selectedYear;
  });

  const [columns, setColumns] = useState([
    {
      headerName: "Year",
      field: "year",
      flex: 1,
      width: 60,
    },
    {
      headerName: "Name",
      field: "participantName",
      sortable: true,
      flex: 1,
    },
    {
      headerName: "Jan",
      field: "jan",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Feb",
      field: "feb",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Mar",
      field: "mar",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Apr",
      field: "april",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "May",
      field: "may",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Jun",
      field: "june",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Jul",
      field: "july",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Aug",
      field: "aug",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Sept",
      field: "sept",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Oct",
      field: "oct",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Nov",
      field: "nov",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
    {
      headerName: "Dec",
      field: "dec",
      sortable: true,
      cellRenderer: formateDataPrec,
      width: 70,
    },
  ]);

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colDef.headerName === "Year") {
          return `${params.value}`;
        }
        if (params.column.colId === "dateColumn") {
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          return `${params.value.toFixed(2)}%`;
        }
        if (
          params.column.colId.includes("Locked") ||
          params.column.colId.includes("Status")
        ) {
          return params.value;
        }
        if (typeof params.value === "undefined") {
          return `--`;
        }
        return params.value !== null ? `${params.value}%` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Historical Performance";
    const headers = [
      [
        "Year",
        "Name",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
    ];

    const transactionData = filteredData.map((e: any) => [
      e.year !== null ? `${e.year}` : "--",
      e.participantName !== null ? `${e.participantName}` : "--",
      e.jan !== null ? formateAsPercent(e.jan) : "--",
      e.feb !== null ? formateAsPercent(e.feb) : "--",
      e.mar !== null ? formateAsPercent(e.mar) : "--",
      e.april !== null ? formateAsPercent(e.april) : "--",
      e.may !== null ? formateAsPercent(e.may) : "--",
      e.june !== null ? formateAsPercent(e.june) : "--",
      e.july !== null ? formateAsPercent(e.july) : "--",
      e.aug !== null ? formateAsPercent(e.aug) : "--",
      e.sept !== null ? formateAsPercent(e.sept) : "--",
      e.oct !== null ? formateAsPercent(e.oct) : "--",
      e.nov !== null ? formateAsPercent(e.nov) : "--",
      e.dec !== null ? formateAsPercent(e.dec) : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("HistoricalPerformance.pdf");
  };

  return (
    <>
      {" "}
      <div className="col-12 d-flex justify-content-between align-items-baseline pt-2">
        <h5 className="mx-2">Historical Performance</h5>
        <div className="col-sm-6 d-flex justify-content-end align-items-baseline">
          <label className="text-small">Filter by Year</label>
          <select
            className="form-control text-small m-3 w-auto"
            onChange={handleSelectedDate}
          >
            <option value="">select Year</option>
            {filterByEndDate?.map((value: any, index: number) => {
              const year = value?.year;
              const formatedYear = year;
              return (
                <option key={index} value={value.year}>
                  {formatedYear}
                </option>
              );
            })}
          </select>
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
      </div>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        {/* {isFetching ? (
          <div className="w-100 grid_loader">
            <div className="spinner-border text-dark me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : ( */}
        <AgGridReact
          ref={dataGridRefMain}
          rowData={filteredData}
          columnDefs={columns}
          animateRows={true}
          domLayout={"normal"}
          pagination={true}
          paginationPageSize={20}
          className="px-2"
          //paginationAutoPageSize={true}
        ></AgGridReact>
        {/* )} */}
      </div>
    </>
  );
};

export { HistoricalPerformance };
